import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SCHEDULE_STATUS, ScheduleResponse } from '@models/report-template.model';

@Component({
  selector: 'app-scheduled-reports-actions-renderer',
  standalone: true,
  imports: [MatIconModule],
  template: `
    <div class="actions-container">
      <button class="actionButton editButton" mat-mini-fab data-action="edit" title="Edit Schedule">
        <mat-icon data-action="edit">edit</mat-icon>
      </button>
      @if (isActive) {
        <button class="actionButton deleteButton" mat-mini-fab data-action="delete" title="Deactivate Schedule">
          <mat-icon data-action="delete">delete</mat-icon>
        </button>
      }
    </div>
  `,
  styles: [`
    .actions-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      gap: 4px;
    }
    .actionButton {
      cursor: pointer;
    }
    .editButton {
      background-color: #0099ab;
      color: white;
    }
    .deleteButton {
      background-color: #dc2626;
      color: white;
    }
  `],
})
export class ScheduledReportsActionsRendererComponent implements ICellRendererAngularComp {
  isActive = true;

  agInit(params: ICellRendererParams): void {
    const schedule = params.data as ScheduleResponse;
    this.isActive = schedule?.statusId === SCHEDULE_STATUS.ACTIVE;
  }

  refresh(params: ICellRendererParams): boolean {
    const schedule = params.data as ScheduleResponse;
    this.isActive = schedule?.statusId === SCHEDULE_STATUS.ACTIVE;
    return true;
  }
}
